import {Button, Dialog, DialogActions, DialogContent, Stack, Typography} from "@mui/material";
import {MyDialogTitle} from "@/components/dialog/MyDialogTitle.tsx";
import {z} from "zod";
import {zodResolver} from "@hookform/resolvers/zod";
import {FormProvider, useForm} from "react-hook-form";
import {FormTextField} from "@/components/form/FormTextField.tsx";
import {useCallback} from "react";
import {
  useCreateZyusetuValueTemplateMutation,
  ZyusetuFieldKeyValueTemplateFragmentFragment
} from "@/graphql/graphql";
import toast from "react-hot-toast";

interface CreateValueTemplateDialogProps {
  open: boolean;
  onClose: () => void;
  currentKeyId: string;
  onCreateSuccess?: (value: ZyusetuFieldKeyValueTemplateFragmentFragment) => Promise<void>;
}

const schema = z.object({
  value: z.string().min(1),
  description: z.string().nullish(),
})

export function CreateValueTemplateDialog(
  {open, onClose, onCreateSuccess, currentKeyId}: CreateValueTemplateDialogProps
) {
  
  const create = useCreateZyusetuValueTemplateMutation()
  
  const form = useForm({
    defaultValues: {
      value: '',
      description: '',
    },
    resolver: zodResolver(schema),
    mode: "onChange"
  })
  
  const onSubmit = useCallback(async (
    value: z.infer<typeof schema>
  ) => {
    const toastId = toast.loading('作成中...')
    await create.mutateAsync({
      keyId: currentKeyId,
      input: value
    }).then(
      (res) => {
        if (res.createZyusetuValueTemplate) {
          toast.success('作成しました', {id: toastId})
          onClose()
          if (onCreateSuccess) {
            onCreateSuccess(res.createZyusetuValueTemplate)
          }
        }
      }
    ).catch(
      () => {
        toast.error('作成に失敗しました', {id: toastId})
      }
    )
  }, [create, currentKeyId, onClose, onCreateSuccess])
  
  return <Dialog open={open} onClose={onClose} maxWidth={'sm'} fullWidth>
    <MyDialogTitle
      onClose={onClose}
    >
      新規作成
    </MyDialogTitle>
    <FormProvider {...form}>
      <form onSubmit={form.handleSubmit(onSubmit)}>
        <DialogContent>
          <Stack spacing={1}>
            
            <Typography variant={'formLabel'}>説明</Typography>
            <FormTextField name={'description'} control={form.control}
                           placeholder={'原状回復義務に関する取り決めがある場合'}/>
            <Typography variant={'formLabel'}>内容</Typography>
            <FormTextField lines={5} name={'value'} control={form.control}
                           placeholder={"居住年数にかかわらず、故意・過失、通常の使用に反する消耗の原状回復義務は借主負担とする"}/>
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose}>キャンセル</Button>
          <Button type={'submit'} variant={'contained'} disabled={!form.formState.isValid}>作成</Button>
        </DialogActions>
      </form>
    </FormProvider>
  
  </Dialog>
}
